// 返点收款信息
import React from "react";
import "./index.less";
import { Row } from "antd";
import { returnFloat } from "../../utils";
import LogoPng from "../../assets/logo.png";

interface Iprops {
  infoData: any;
  isMobile: boolean;
}

/**
 * 达人支付信息显示
 */
function PayInfo(props: Iprops) {
  const { infoData, isMobile } = props;

  const tableEnum = [
    {
      name: "执行单名称",
      key: "executeName",
    },
    {
      name: "达人昵称",
      key: "kolScheduleName",
    },
    {
      name: "发布平台",
      key: "platform",
    },
    {
      name: "合作方式",
      key: "form",
    },
    {
      name: "发布日期",
      key: "date",
    },
    {
      name: "返点回收金额",
      key: "uncollectedAmount",
      type: "money",
    },
  ];

  return (
    <>
      {isMobile ? (
        <div className="company-logo">
          <img src={LogoPng} alt="" />
        </div>
      ) : (
        <Row>
          <div className="title">众引合作-返点支付</div>
        </Row>
      )}

      <div className="hint mb20 greeting">
        尊敬的<span>{infoData.kolScheduleName}</span>
      </div>
      <div className="hint mb10">
        本次您与众引合作的"
        <span className="project-name">
          {infoData.customerBrand}-{infoData.executeName}
        </span>
        "投放已完成
      </div>
      <div className="hint mb20">请核对以下信息无误后完成返点支付</div>
      <div className="rebate-table">
        {tableEnum.map((item) => (
          <div className="row" key={item.key}>
            <div className="left">{item.name}</div>
            <div className={item?.type === "money" ? "right money" : "right"}>
              {item?.type === "money"
                ? "￥" + returnFloat(infoData?.[item.key] || 0)
                : infoData?.[item.key]}
            </div>
          </div>
        ))}
      </div>
      {infoData.uncollectedAmount === 0 && isMobile && (
        <div className="hint">返点已支付！感谢您的配合，期待下次合作 ！</div>
      )}
    </>
  );
}

export default PayInfo;
